function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.4 14.1622C6.4 14.8243 5.86274 15.361 5.2 15.361C4.53726 15.361 4 14.8243 4 14.1622C4 13.5001 4.53726 12.9634 5.2 12.9634C5.86274 12.9634 6.4 13.5001 6.4 14.1622Z",
  fill: "#243041"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.2 16.9594C9.86274 16.9594 10.4 16.4227 10.4 15.7606C10.4 15.0985 9.86274 14.5618 9.2 14.5618C8.53726 14.5618 8 15.0985 8 15.7606C8 16.4227 8.53726 16.9594 9.2 16.9594Z",
  fill: "#243041"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6 14.1622C25.6 14.8243 26.1373 15.361 26.8 15.361C27.4627 15.361 28 14.8243 28 14.1622C28 13.5001 27.4627 12.9634 26.8 12.9634C26.1373 12.9634 25.6 13.5001 25.6 14.1622Z",
  fill: "#243041"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8 16.9594C22.1373 16.9594 21.6 16.4227 21.6 15.7606C21.6 15.0985 22.1373 14.5618 22.8 14.5618C23.4627 14.5618 24 15.0985 24 15.7606C24 16.4227 23.4627 16.9594 22.8 16.9594Z",
  fill: "#243041"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 32.9431C24.8366 32.9431 32 25.7869 32 16.9594C32 8.13182 24.8366 0.975616 16 0.975616C7.16344 0.975616 0 8.13182 0 16.9594C0 25.7869 7.16344 32.9431 16 32.9431ZM16.8 31.3229C24.3808 30.9082 30.4 24.6361 30.4 16.9594C30.4 9.01452 23.9529 2.57399 16 2.57399C8.0471 2.57399 1.6 9.01452 1.6 16.9594C1.6 24.6361 7.6192 30.9082 15.2 31.3229V20.8754C13.3742 20.5051 12 18.8926 12 16.9594C12 14.7524 13.7909 12.9634 16 12.9634C18.2091 12.9634 20 14.7524 20 16.9594C20 18.8926 18.6258 20.5051 16.8 20.8754V31.3229ZM16 19.3569C17.3255 19.3569 18.4 18.2835 18.4 16.9594C18.4 15.6352 17.3255 14.5618 16 14.5618C14.6745 14.5618 13.6 15.6352 13.6 16.9594C13.6 18.2835 14.6745 19.3569 16 19.3569Z",
  fill: "#243041"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.04424990.svg";
export { ForwardRef as ReactComponent };